import { useState } from 'react'

import { uploadGuideSteps } from './steps'

export type StepDirection = 1 | -1

const LAST_INDEX = uploadGuideSteps.length - 1

export const useGuideSteps = () => {
  const [stepIndex, setStepIndex] = useState(0)
  const [direction, setDirection] = useState<StepDirection>(1)

  const goTo = (nextIndex: number) => {
    setDirection(nextIndex > stepIndex ? 1 : -1)
    setStepIndex(nextIndex)
  }

  return {
    step: uploadGuideSteps[stepIndex] ?? uploadGuideSteps[0],
    stepIndex,
    stepKeys: uploadGuideSteps.map((step) => step.key),
    direction,
    isLastStep: stepIndex === LAST_INDEX,
    goNext: () => goTo(Math.min(stepIndex + 1, LAST_INDEX)),
    goBack: () => goTo(Math.max(stepIndex - 1, 0)),
  }
}
